module.exports = __webpack_public_path__ + "static/img/oppoReno2.bef7a7da.png";